'use client'
import Loader from 'components/loader'
import PageLayout from 'components/page-layout'
import {
  AccessManagement,
  DeviceManagement,
  HybridWorksCarousel,
  ITManagement,
  IdentityManagement,
  ProductVideo,
} from 'page-components/home-page'
import Hero from 'page-components/home-page/Hero'
import Client from 'page-components/home-page/client'
import React, {Suspense} from 'react'

export default function Page() {
  return (
    <PageLayout showExtraSection={true}>
      <Hero />
      <Client />
      <Suspense fallback={<Loader />}>
        <ProductVideo />
        <ITManagement />
        <IdentityManagement />
        <AccessManagement />
        <DeviceManagement />
        <HybridWorksCarousel />
      </Suspense>
    </PageLayout>
  )
}
